/**
 * Updates a specific canvas feed's media or assets
 * @param {Object} canvasFeedMap - The main canvas feed map object
 * @param {string} canvasId - The canvas ID to update
 * @param {string} type - Either 'media' or 'assets'
 * @param {Object} items - Items to update
 * @returns {Object} Updated canvas feed map
 */
export const updateCanvasFeedItems = (canvasFeedMap, canvasId, type, items) => {
	return {
		...canvasFeedMap,
		[canvasId]: {
			...(canvasFeedMap[canvasId] ?? {}),
			[type]: {
				...(canvasFeedMap[canvasId]?.[type] ?? {}),
				...items,
			},
		},
	};
};

/**
 * Sets data of a specific canvas feed's media or assets
 * @param {Object} canvasFeedMap - The main canvas feed map object
 * @param {string} canvasId - The canvas ID to update
 * @param {string} type - Either 'media' or 'assets'
 * @param {Object} items - Items to add
 * @returns {Object} Updated canvas feed map
 */
export const addCanvasFeedItems = (canvasFeedMap, canvasId, type, items) => {
	return {
		...canvasFeedMap,
		[canvasId]: {
			...(canvasFeedMap[canvasId] ?? {}),
			[type]: items,
		},
	};
};

/**
 * Removes items from a canvas feed
 * @param {Object} canvasFeedMap - The main canvas feed map object
 * @param {string} canvasId - The canvas ID containing the items
 * @param {string} type - Either 'media' or 'assets'
 * @param {string[]} itemIds - Array of item IDs to remove
 * @returns {Object} Updated canvas feed map
 */
export const removeCanvasFeedItems = (canvasFeedMap, canvasId, type, itemIds) => {
	const currentCanvasFeed = canvasFeedMap[canvasId];
	if (!currentCanvasFeed?.[type]) return canvasFeedMap;

	const updatedItems = { ...currentCanvasFeed[type] };
	itemIds.forEach((id) => delete updatedItems[id]);

	return {
		...canvasFeedMap,
		[canvasId]: {
			...currentCanvasFeed,
			[type]: updatedItems,
		},
	};
};
